import React, { useState, useEffect } from "react";
import "./entity.css";
import { Drawer,Grid,Table,TableBody,TableContainer,TableHead,TableRow, Paper,Button,Menu,Skeleton,TableCell,MenuItem} from "@mui/material";
import Swal from "sweetalert2";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import instance from "../../ApiInstance/Inetrceptor";
import AddIcon from "@mui/icons-material/Add";
import StyledTableCell from "../../Tabletheme/Customtableheader";
import EntityTypedrawer from "./EntityTypedrawer";
import CustomTheme from "../../Customtheme/Themes"

const EntityTypes = () => {
  const { drawerWidth, isXs, isSm, isMd, isLg, isXl } = CustomTheme();
  const [loader, setLoader] = useState(true);
  const [showmoreLoader, setShowmoreLoader] = useState(false);
  const [selectedItems, setSelectedItems] = useState([]);
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const [pageNo, setPageNo] = useState(1);
  const [totalRecods, setTotalRecods] = useState(0);
  const [sortField, setSortField] = useState("entity_type_name");
  const [sortOrder, setSortOrder] = useState("asc");
  const [getentitydata, setGetentitydata] = useState([]);
  const [entityTypedata, setEntityTypedata] = useState({});
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedRowIndex, setSelectedRowIndex] = useState(null);
  const [searchText, setSearchText] = useState("");
  const [isAddSectionOpen, setIsAddSectionOpen] = useState(false);
  const [isEditSectionOpen, setIsEditSectionOpen] = useState(false);
  const [backDrop, setBackDrop] = useState(false);
  const [addentity, setAddentity] = useState({
    entity_type_id: 0,
    entity_type_name: "",
    entity_type_desc: "",
  });
  const open = Boolean(anchorEl);
  const deleteMaintainData = (entityId) => {
    instance
      .delete(`api/v1/Master/EntityType/Delete/${entityId}`)
      .then((res) => {
        const ResultData = res?.data?.ResultMessage ?? [];
        if (ResultData === "Deletion Success") {
          setGetentitydata((prevData) => {
            return prevData.filter(row => row.entity_type_id !== entityId);
          });
           GetEntityData();
          Swal.fire({
            icon: "success",
            title: "Deleted!",
            text: ResultData,
            customClass: {
              confirmButton: "custom-confirm-button-class",
            },
            buttonsStyling: false,
            showCancelButton: false,
            confirmButtonText: "OK",
            allowOutsideClick: false,
            // onClose: () => {
            //   const updatedMaintainData = getentitydata.filter(
            //     (item) => item?.entity_type_id !== entityId
            //   );
            //   setGetentitydata(updatedMaintainData);
            // },
          });
        } else {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: ResultData,
            customClass: {
              confirmButton: "custom-cancle-button-class",
            },
            buttonsStyling: false,
            showCancelButton: false,
            confirmButtonText: "OK",
          });
        }
      })
      .catch((err) => {
        console.log("newData12", err);
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
          customClass: {
            confirmButton: "custom-cancle-button-class",
          },
          buttonsStyling: false,
          showCancelButton: false,
          confirmButtonText: "OK",
        });
      })
      .finally(() => {
        setLoader(false);
        setShowmoreLoader(false);
      });
  };
  const handleClose = (event, rowdata, index) => {
    if (event.target.innerText === "Edit") {
      setEntityTypedata(rowdata);
      setIsDrawerOpen(true);
      setAnchorEl(null);
      setSelectedRowIndex(null);
    } else if (event.target.innerText === "Delete") {
      Swal.fire({
        icon: "question",
        text: "Are you sure you want to delete",
        customClass: {
          confirmButton: "custom-confirm-button-class",
          cancelButton: "custom-cancle-button-class",
        },
        buttonsStyling: false,
        showCancelButton: true,
        confirmButtonText: "OK",
        cancelButtonText: "Cancel",
        allowOutsideClick: false,
        reverseButtons: true, 
      }).then((responce) => {
        if (responce?.isConfirmed) {
          deleteMaintainData(rowdata?.entity_type_id);
        } else {
        }
      });
    }
    setAnchorEl(null);
    setSelectedRowIndex(null);
  };
  const handleEditClick = (event, index) => {
    setAnchorEl(event.currentTarget);
    setSelectedRowIndex(index);
    setIsAddSectionOpen(false);
    setIsEditSectionOpen(true);
  };
  const handleCloseErrorcode = () => {
    setError("");
  };
  const handleSort = (field) => {
    const order = field === sortField && sortOrder === "asc" ? "desc" : "asc";
    setSortField(field);
    setSortOrder(order);
    GetEntityData(pageNo, field, order);
  };
  const GetEntityData = (
    pageNumber = pageNo,
    field = sortField,
    order = sortOrder,
    searchText
  ) => {
    const body = {
      id: "",
      searchtext: searchText,
      pageno: pageNumber,
      pagesize: 10,
      sortby: field ?? "",
      sortord: order ?? "",
    };
    instance
      .post("api/v1/Master/EntityType/Get", body)
      .then((res) => {
        const newData = res?.data?.Value ?? [];
        console.log("res", res);
        setTotalRecods(res?.data?.Records);
        if (pageNumber === 1) {
          setGetentitydata(res?.data?.Value ?? []);
        } else {
          setGetentitydata((prevData) => [...prevData, ...newData]);
        }
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        setLoader(false);
        setShowmoreLoader(false);
      });
  };
  const handleButtonClick = () => {
    setIsDrawerOpen(true);
    setIsAddSectionOpen(true);
    setIsEditSectionOpen(false);
  };

  const handleDrawerClose = (event) => {
    setIsDrawerOpen(false);
    setIsAddSectionOpen(false);
    setIsEditSectionOpen(false);
  };
  const handleInputChange = (event) => {
    const { id, value } = event.target;
    setAddentity((prevData) => ({
      ...prevData,
      [id]: value,
    }));
  };
  const handleEditChange = (event) => {
    const { id, value } = event.target;
    setEntityTypedata((prevData) => ({
      ...prevData,
      [id]: value,
    }));
  };
  const handle_createEntity = (event) => {
    event.stopPropagation();
    setIsDrawerOpen(true);
    const entityname = addentity.entity_type_name.trim();
    const entityadd = addentity.entity_type_desc.trim();

    if (!entityname || !entityadd) {
      setError("Please enter all the fields mandatory.");
      setTimeout(() => {
        handleCloseErrorcode();
      }, 5000);
    } else {
      setBackDrop(true);
      const body = {
        entity_type_id: 0,
        entity_type_name: addentity.entity_type_name,
        entity_type_desc: addentity.entity_type_desc,
      };
      instance
        .post("api/v1/Master/EntityType/Post", body)
        .then((res) => {
          console.log("resp", res);
          setSuccess(res?.data?.ResultMessage);
          GetEntityData(1);
          setTimeout(() => {
            setSuccess(null);
          }, 5000);
          setError("");
          setAddentity({
            entity_type_name: "",
            entity_type_desc: "",
          });
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          setBackDrop(false);
        });
    }
  };
  const handle_EditEntity = (event) => {
    event.stopPropagation();
    setIsDrawerOpen(true);
    const entityname = entityTypedata.entity_type_name.trim();
    const entityadd = entityTypedata.entity_type_desc.trim();

    if (!entityname || !entityadd) {
      setError("Please enter all the fields mandatory.");
      setTimeout(() => {
        handleCloseErrorcode();
      }, 5000);
    } else {
      setBackDrop(true);
      const body = {
        entity_type_id: entityTypedata.entity_type_id,
        entity_type_name: entityTypedata.entity_type_name,
        entity_type_desc: entityTypedata.entity_type_desc,
      };
      instance
        .post("api/v1/Master/EntityType/Post", body)
        .then((res) => {
          console.log("resp", res);
          setSuccess(res?.data?.ResultMessage);
          GetEntityData(1);
          setTimeout(() => {
            setSuccess(null);
          }, 5000);
          setError("");
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          setBackDrop(false);
        });
    }
  };
  useEffect(() => {
    GetEntityData(pageNo, sortField, sortOrder);
  }, [sortField, sortOrder]);
  return (
    <>
      <div className="parent_div">
        <div
          style={{ display: "flex", justifyContent: "space-between" }}
          className="mb-4"
        >
          <p className="heading_font">Entity Types</p>
          <p className="head_div"></p>
        </div>
        <Grid container justifyContent="space-between" spacing={2}>
          <Grid item xl={1.8} lg={2.3} md={6} sm={12} xs={12}>
            <Button
              variant="contained"
              className="button_header"
              onClick={handleButtonClick}
              color="secondary"
              sx={{
                width: "100%",
                textTransform: "none",
              }}
            >
              Add Entity Type <AddIcon />
            </Button>
          </Grid>
          <Grid item xl={3} lg={3} md={6} sm={12} xs={12}>
            <div className="search-section d-flex">
              <div>
                <img src="assets/Images/searchicon.svg" alt="Search Icon" />
              </div>
              <div className="search-input">
                <input
                  onKeyUp={(event) => {
                    if (event.key === "Enter") {
                      GetEntityData(
                        1,
                        sortField,
                        sortOrder,
                        event.target.value
                      );
                    }
                  }}
                  onChange={(event) => {
                    setSearchText(event.target.value);
                    if (event.target.value.length === 0) {
                      GetEntityData(1, sortField, sortOrder, "");
                    }
                  }}
                  type="text"
                  placeholder="Search / Filter"
                />
              </div>
            </div>
          </Grid>
        </Grid>
        <Drawer
          anchor="right"
          open={isDrawerOpen}
          PaperProps={{
            sx: {
              width: drawerWidth},}}>
      <EntityTypedrawer 
      error={error}
      success={success}
      addentity={addentity}
      handleDrawerClose={handleDrawerClose}
      isAddSectionOpen={isAddSectionOpen}
      handleCloseErrorcode={handleCloseErrorcode}
      handleInputChange={handleInputChange}
      handleEditChange={handleEditChange}
      handle_createEntity={handle_createEntity}
      handle_EditEntity={handle_EditEntity}
      isEditSectionOpen={isEditSectionOpen}
      entityTypedata={entityTypedata}/>
        </Drawer>
        <TableContainer sx={{ marginTop: 5, maxHeight: 600 }} component={Paper}>
          <Table stickyHeader>
            <TableHead>
              <TableRow className="Table_row">
                <StyledTableCell />
                <StyledTableCell onClick={() => handleSort("entity_type_name")}>
                  Name
                  {sortField === "entity_type_name" && (
                    <>
                      {sortOrder === "asc" ? (
                        <img
                          src="assets/Images/Ascending.svg"
                          alt="Ascending"
                          style={{ width: "3%", marginLeft: "5px" }}
                        />
                      ) : (
                        <img
                          src="assets/Images/descending.svg"
                          alt="Descending"
                          style={{ width: "3%", marginLeft: "5px" }}
                        />
                      )}
                    </>
                  )}
                </StyledTableCell>
                <StyledTableCell>Description</StyledTableCell>
                <StyledTableCell />
              </TableRow>
            </TableHead>
            {loader ? (
              <>
                {new Array(5).fill(3).map((element, index) => {
                  return (
                    <TableRow key={index}>
                      {new Array(4).fill(1).map((element, index) => {
                        return (
                          <TableCell align="center" key={index}>
                            <Skeleton
                              variant="rounded"
                              width={"100%"}
                              height={60}
                            />
                          </TableCell>
                        );
                      })}
                    </TableRow>
                  );
                })}
              </>
            ) : (
              <>
                {getentitydata.length === 0 ? (
                  <TableRow>
                    <TableCell colSpan={7} align="center">
                      <p>No Data Found</p>
                    </TableCell>
                  </TableRow>
                ) : (
                  <TableBody>
                    {getentitydata.map((row, index) => (
                      <TableRow key={index}>
                         {/* key={row.id}> */}
                        <TableCell padding="checkbox">
                        </TableCell>
                        <TableCell style={{ minWidth: "15rem", maxWidth: "15rem"}}>{row.entity_type_name}</TableCell>
                        <TableCell style={{ minWidth: "25rem", maxWidth: "25rem"}}>{row.entity_type_desc}</TableCell>
                        <TableCell style={{ minWidth: "5rem", maxWidth: "5rem"}}>
                          <div style={{ textAlign: "center" }}>
                            <MoreVertIcon
                              onClick={(event) => handleEditClick(event, index)}
                              id="basic-button"
                              aria-controls={
                                Boolean(anchorEl)
                                  ? `basic-menu-${index}`
                                  : undefined
                              }
                              aria-haspopup="true"
                              aria-expanded={
                                Boolean(anchorEl) ? "true" : undefined
                              }
                            />

                            <Menu
                              id={`basic-menu-${index}`}
                              anchorEl={anchorEl}
                              open={
                                selectedRowIndex !== null &&
                                selectedRowIndex === index
                              }
                              onClose={handleClose}
                              MenuListProps={{
                                "aria-labelledby": `basic-button-${index}`,
                              }}
                            >
                              <MenuItem
                                onClick={(event) => {
                                  handleClose(event, row, index);
                                }}
                              >
                                Edit
                              </MenuItem>
                              <MenuItem
                                onClick={(event) => {
                                  handleClose(event, row, index);
                                }}
                              >
                                Delete
                              </MenuItem>
                            </Menu>
                          </div>
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                )}
              </>
            )}
          </Table>
        </TableContainer>
        <Grid item xs={12} className="mt-4" sx={{ textAlign: "center" }}>
          {totalRecods > getentitydata.length && getentitydata.length > 0 && (
            <Button
              id="back-button"
              variant="contained"
              color="secondary"
              sx={{ textTransform: "none" }}
              onClick={() => {
                setShowmoreLoader(true);
                setPageNo((prev) => prev + 1);
                GetEntityData(pageNo + 1, sortField, sortOrder);
              }}
            >
              {showmoreLoader ? "loading" : "Show More"}
            </Button>
          )}
        </Grid>
      </div>
    </>
  );
};

export default EntityTypes;
